export default "__VITE_PUBLIC_ASSET__7d6200d2__"